import styled, { css } from 'styled-components';

interface InputProps {
  size?: string;
}

const inputSize = (props: InputProps) => {
  let width = '16px';
  let height = '16px';

  switch (props.size) {
    case 'large':
      width = '26px';
      height = '26px';
      break;
    default:
  }

  return css`
    width: ${width};
    height: ${height};
  `;
};

export const Input = styled.input<InputProps>`
  margin: 0;
  position: absolute;
  ${inputSize};
  opacity: 0;

  &:checked + span {
    border-color: ${props => props.theme.colors.primary};
    background-color: ${props => props.theme.colors.primary};
    background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9IiNmZmZmZmYiIHN0cm9rZS13aWR0aD0iMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBjbGFzcz0ibHVjaWRlIGx1Y2lkZS1jaGVjay1pY29uIGx1Y2lkZS1jaGVjayI+PHBhdGggZD0iTTIwIDYgOSAxN2wtNS01Ii8+PC9zdmc+");
    background-repeat: no-repeat;
    background-position: center;
    &:before {
      color: white;
      content: "";
    }
  }
`;

interface Props {
  size?: string;
  isBlink: boolean;
  disabled: boolean;
}

const checkboxSize = (props: Props) => {
  let width = '14px';
  let height = '14px';
  let fontSize = '10px';

  switch (props.size) {
    case 'large':
      width = '24px';
      height = '24px';
      fontSize = '12px';
      break;
    default:
  }

  return css`
    width: ${width};
    height: ${height};
    font-size: ${fontSize};
    line-height: ${height};
    border-radius: 3px;
  `;
};

export const Checkbox = styled.div<Props>`
  ${props => props.isBlink && `
    animation: blinker 1s linear;
  `}

  span {
    display: block;
    box-sizing: border-box;
    border: 1px solid transparent;
    border-color: ${props => (props.disabled ? '#d2d2d2' : '#767676')};
    ${checkboxSize};
  }

  & + label {
    user-select: none;
  }

  @keyframes blinker {
      25% {
          opacity: 0;
      }
      50% {
          opacity: 1;
      }
      75% {
          opacity: 0;
      }
  }
`;
